import React from 'react';
import { navigate } from 'gatsby';
import { Helmet } from 'react-helmet';

import Header from '../Header';
import Footer from '../Footer';
import {
  getPageLang, getBaseUrl, getPreferredLang, i18n,
} from '../../utils/i18n';
import './Layout.css';

class Layout extends React.Component {
  constructor() {
    super();
    this.state = {
      preferredLang: null,
    };
  }

  componentDidMount() {
    const { pageContext } = this.props;
    const pageLang = getPageLang(pageContext);

    // If we land on this page but it's not in our preferred
    // language (when it exists), we navigate to our preferred
    // language.
    if (pageContext.locale !== pageLang) {
      // eslint-disable-next-line no-restricted-globals,no-undef
      navigate(`/${pageLang}${getBaseUrl(location.pathname)}`);
    }

    this.setState({
      preferredLang: getPreferredLang(),
    });
  }

  render() {
    const { children, pageContext } = this.props;
    const { preferredLang } = this.state;
    return (
      <>
        <Helmet>
          <meta httpEquiv="content-language" content={getPageLang(pageContext)} />
          <title>
            {pageContext.title}
            {' '}
            -
            {' '}
            {i18n(preferredLang, 'ghostIslandMedia')}
          </title>

          <link rel="apple-touch-icon" href="/apple-touch-icon.png" />
          <link rel="icon" type="image/png" href="/favicon.png" />

          <meta name="title" content={pageContext.title} />
          <meta name="description" content={pageContext.description} />
          <meta property="og:title" content={`${pageContext.title} - ${i18n(preferredLang, 'ghostIslandMedia')}`} />
          <meta property="og:type" content="website" />
          <meta property="og:url" content={`https://ghostisland.media/${pageContext.pagePath}`} />
          {pageContext.rss ? (<meta property="og:image" content={`https://omny.fm/shows/${pageContext.page}/playlists/podcast/image.jpg?size=wideShare`} />) : null}
          <meta property="og:site_name" content={i18n(preferredLang, 'ghostIslandMedia')} />
          <meta property="og:locale" content={getPageLang(pageContext)} />
          <meta property="og:description" content={pageContext.description} />

          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content={`${pageContext.title} - ${i18n(preferredLang, 'ghostIslandMedia')}`} />
          {pageContext.rss ? (<meta name="twitter:image" content={`https://omny.fm/shows/${pageContext.page}/playlists/podcast/image.jpg?size=wideShare`} />) : null}

          <script async src="https://www.googletagmanager.com/gtag/js?id=G-R2DQVC46GS" />
          <script>
            {`
              window.dataLayer = window.dataLayer || [];
              function gtag(){dataLayer.push(arguments);}
              gtag('js', new Date());
  
              gtag('config', 'G-R2DQVC46GS');
          `}
          </script>
        </Helmet>

        <Header locale={preferredLang || pageContext.locale} />
        <main lang={pageContext.locale}>
          {children}
        </main>
        <Footer locale={preferredLang || pageContext.locale} />
      </>
    );
  }
}

export default Layout;
